import React, { useState } from 'react';

interface DeepLinkUIStateDebugMonitorProps {
    applicationName?: string;
    getUIStateForDebugMonitor: () => any;
}

export const DeepLinkUIStateDebugMonitor = ({
    applicationName,
    getUIStateForDebugMonitor
}: DeepLinkUIStateDebugMonitorProps) => {
    const [uiStateForDebugMonitor, setUIStateForDebugMonitor] = useState(getUIStateForDebugMonitor);
    const refreshUIStateForDebugMonitor = () => {
        setUIStateForDebugMonitor(getUIStateForDebugMonitor());
    };

    const initialUIStateText = JSON.stringify(uiStateForDebugMonitor.uiInitialState, null, 2);
    const runtimeUIStateText = JSON.stringify(uiStateForDebugMonitor.uiRuntimeState, null, 2);
    const consumptionLedgerText = JSON.stringify(Array.from(uiStateForDebugMonitor.consumptionLedger.initial), null, 2);
    const buttonStyle = {
        fontSize: '10px',
        border: '1px solid lightgray',
        padding: '0.25rem 0.25rem',
        borderRadius: '0.25rem'
    };
    const hrStyle = {
        width: '100%',
        border: 'none',
        borderTop: '1px solid lightgray'
    };
    return (
        <div
            style={{
                position: 'fixed',
                bottom: '4rem',
                left: '4rem',
                backgroundColor: 'rgba(250, 250, 250, 0.7)',
                padding: '10px',
                borderRadius: '1rem',
                zIndex: 10000,
                maxWidth: '400px',
                maxHeight: '50vh',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
            }}
        >
            <div
                style={{
                    display: 'flex',
                    gap: '1rem',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
            >
                <span
                    style={{
                        fontSize: '12px',
                        lineHeight: '1',
                        fontWeight: 'bold',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}
                >
                    Deep Link UI State Debug Monitor
                </span>
                <button type="button" onClick={refreshUIStateForDebugMonitor} style={buttonStyle}>
                    Refresh
                </button>
            </div>
            <hr style={hrStyle} />
            <div style={{ overflowY: 'auto', flex: 1, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                <pre style={{ fontSize: '10px' }}>
                    <span style={{ width: '100%', display: 'inline-flex', justifyContent: 'space-between' }}>
                        Application <CopyButton style={buttonStyle} text={applicationName} />
                    </span>
                    <br />
                    <span>{applicationName}</span>
                </pre>
                <hr style={hrStyle} />
                <pre style={{ fontSize: '10px' }}>
                    <span style={{ width: '100%', display: 'inline-flex', justifyContent: 'space-between' }}>
                        Initial UI State <CopyButton style={buttonStyle} text={initialUIStateText} />
                    </span>
                    <br />
                    <span>{initialUIStateText}</span>
                </pre>
                <hr style={hrStyle} />
                <pre style={{ fontSize: '10px' }}>
                    <span style={{ width: '100%', display: 'inline-flex', justifyContent: 'space-between' }}>
                        Runtime UI State <CopyButton style={buttonStyle} text={runtimeUIStateText} />
                    </span>
                    <br />
                    <span>{runtimeUIStateText}</span>
                </pre>
                <hr style={hrStyle} />
                <pre style={{ fontSize: '10px' }}>
                    <span style={{ width: '100%', display: 'inline-flex', justifyContent: 'space-between' }}>
                        Initial State Consumed <CopyButton style={buttonStyle} text={consumptionLedgerText} />
                    </span>
                    <br />
                    <span>{consumptionLedgerText}</span>
                </pre>
            </div>
        </div>
    );
};

const CopyButton = ({ text, style }) => {
    return (
        <button
            type="button"
            onClick={async () => {
                try {
                    await navigator.clipboard?.writeText(text);
                } catch (error) {
                    console.debug('Failed to copy deep link debug text to clipboard', error);
                }
            }}
            style={style}
        >
            Copy
        </button>
    );
};
